import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import { getBenefitSummaryThunk, getSinglePolicy } from "store/thunk/kyp.thunk";
import { useParams } from "react-router-dom";

import BenefitSummaryV1 from "./benefitSummaryV1";
import BenefitSummartV2 from "./benefitSummartV2";

const BenefitSummary = () => {
  const param: any = useParams();
  const dispatch = useAppDispatch();

  const benefitSummaryList = useAppSelector((state) => state.rootReducer.kypSlice.benefitSummary);

  useEffect(() => {
    dispatch(getBenefitSummaryThunk(param?.policyId));
    dispatch(getSinglePolicy(param?.policyId));
  }, [dispatch, param]);

  return <>{benefitSummaryList?.version === 2 ? <BenefitSummartV2 /> : <BenefitSummaryV1 />}</>;
};

export default BenefitSummary;
